import { useState, useEffect } from "react";
import { getDictionaries } from "../services/siteService";
export const useDictionaryOptions = dictCodes => {
  const [dicts, setDicts] = useState([]);
  const init = async () => {
    const _dicts = await getDictionaries(dictCodes);
    const dicts = _dicts.map(x => {
      return x.map(y => ({
        code: y.dicCode,
        value: y.dicName
      }));
    });
    setDicts(dicts);
  };
  useEffect(() => {
    init();
  }, []);
  return dicts;
};
